import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ConfigService } from 'src/app/infrastructure/services/config-services/config.service';
import { components } from 'src/assets/api/schema';
import { SKIP_RESPONSE_STATE } from 'src/app/auth/helpers/skip-response-state.token';

type DomainDefaultProfileDto = components['schemas']['DomainDefaultProfileDto'];

// Thin wrapper rond het anonieme domain-0-endpoint (SSOT-fallback voor loginscherm +
// favicon). Gebruikt bewust een kale HttpClient i.p.v. de gedeelde ApiService: ApiService
// -> ResponseStateService -> DomainProfileService -> (deze service) -> ApiService zou een
// circulaire DI-dependency vormen (DomainProfileService roept dit al in zijn constructor aan).
// De globale responseInterceptor injecteert ZELF ook ResponseStateService (voor elke
// HttpClient-call, dus ook deze "kale" call) — vandaar SKIP_RESPONSE_STATE, anders gooit
// Angular alsnog NG0200 (DomainProfileService staat dan nog op de constructor-call-stack).
@Injectable({ providedIn: 'root' })
export class DomainDefaultProfileApiService {
    private __http = inject(HttpClient);
    private __configService = inject(ConfigService);

    async Default_get(): Promise<DomainDefaultProfileDto | null> {
        const __url = `${this.__configService.originApi$$() ?? ''}/api/Domain/default`;
        const __result$ = this.__http.get<DomainDefaultProfileDto>(__url, {
            context: new HttpContext().set(SKIP_RESPONSE_STATE, true),
        }).pipe(
            catchError(() => of(null)),
        );
        return firstValueFrom(__result$);
    }
}
